import { URLParser } from '../utils/URLParser';

export const searchParamValue = (traffic, key) => {
  const urlObject = new URLParser(traffic.url);
  return urlObject.searchParams.get(key);
};
